import React from "react";

const EmptyState = ({ text }) => (
  <div className="text-muted text-center super-admin-empty" style={{ fontSize: "13px" }}>
    {text}
  </div>
);

export default EmptyState;
